import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoriiProiecteComponent } from './categorii-proiecte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddCategoriiProiecteComponent } from './add-categorii-proiecte/add-categorii-proiecte.component';
import { EditCategoriiProiecteComponent } from './edit-categorii-proiecte/edit-categorii-proiecte.component';

@NgModule({
    declarations: [
        CategoriiProiecteComponent,
        AddCategoriiProiecteComponent,
        EditCategoriiProiecteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [CategoriiProiecteComponent],
})
export class CategoriiProiecteModule { }
